import { useParams } from 'react-router-dom';

import { Flow_Types } from '@occc-app/offerHelpers/types';

import { MessagingCampaignUpdatePage } from './messaging-campaign-update.page';
import { getUpdateBreadcrumbLinks } from './messaging-campaign-update.utils';

import { CONFIGURE_PAGE_TITLE } from '../../messaging-center.constants';
import { useGetContainerProps } from '../messaging-campaign-configure/hooks/use-get-container-props.hook';

export const MessagingCampaignUpdatePageContainer = () => {
  const { id: campaignId = '' } = useParams<{
    id: string;
  }>();

  const containerParams = {
    getBreadcrumbLinks: (name: string) =>
      getUpdateBreadcrumbLinks({
        campaignId,
        campaignName: name,
        pageTitle: CONFIGURE_PAGE_TITLE,
      }),
  };

  const {
    layoutProps,
    configureFormProps,
    targetFormProps,
    scheduleFormProps,
    dialogProps,
    breadcrumbLinks,
  } = useGetContainerProps({ ...containerParams, campaignId, flowType: Flow_Types.Update });

  return (
    <MessagingCampaignUpdatePage
      dialogProps={dialogProps}
      layoutProps={layoutProps}
      configureFormProps={configureFormProps}
      targetFormProps={targetFormProps}
      scheduleFormProps={scheduleFormProps}
      breadcrumbLinks={breadcrumbLinks}
    />
  );
};
